import React, { useEffect, useRef, useState } from "react";
import { RecipientUsersDialog } from "components/Dialogs";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import Swal from "sweetalert2";
import { Button } from "../StyledElements";
import { deleteEmailCampaignRecipient } from "services/emailcampaigns";

DataTable.use(DT);

const RecipientsTable = ({ emailCampaign, hideTitle = false, hideButtons = false, showAddExisting = false, mode = null, onSelect = () => { } }) => {
  const [localRecipients, setLocalRecipients] = useState(emailCampaign.recipients);
  const [showRecipientUsersDialog, setShowRecipientUsersDialog] = useState(false);
  const tableRef = useRef(null);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    console.log("!!! RECIPIENTS: ", emailCampaign.recipients);
    if (emailCampaign.recipients) {
      setLocalRecipients(emailCampaign.recipients);
    }
  }, [emailCampaign]);

  window.edit = (public_id) => {
  };


  window.delete = (public_id) => {
    console.log("!!! PUBLIC ID: ", public_id);
    Swal.fire({
      title: "Are you sure?",
      text: "This will remove the recipient from the email campaign.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.value) {
        setDeleting(true);
        const results = await deleteEmailCampaignRecipient(public_id);
        if (!results.success) {
          Swal.fire("Error!", results.message, "error");
          setDeleting(false);
          return;
        }
        const updatedRecipients = localRecipients.filter((recipient) => recipient.public_id !== public_id);
        setLocalRecipients(updatedRecipients);
        onSelect(updatedRecipients);
        setDeleting(false);
        Swal.fire("Deleted!", "The recipient has been removed.", "success");
      }
    });
  }


  const tableData = localRecipients.map((recipient) => {
    return [
      `<div style="text-overflow: ellipsis; width: 92px; overflow: hidden; white-space: nowrap" title="${recipient.public_id}">${recipient.public_id}</div>`,
      recipient.name,
      recipient.email,
      recipient.status,
      recipient.created_at ? new Date(recipient.created_at).toLocaleString() : "",
      recipient.sent_at ? new Date(recipient.sent_at).toLocaleString() : "",
      `<div style="display: flex; flex-direction: row; gap: 10px;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.delete('${recipient.public_id}')" class="bg-red-400 text-black active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" style="color: black !important" type="button">X</button></div>`,
    ];
  });

  return (
    <div style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px" }}>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", fontSize: "32px", fontWeight: "bold" }}>
        <div style={{ fontSize: "16px", fontStyle: "italic", fontWeight: "normal" }}>
          {localRecipients.length.toLocaleString()} recipients
        </div>
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <Button
            onClick={() => {
              setShowRecipientUsersDialog(true);
            }}
          >+ Add Recipient</Button>
        </div>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[0, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Date Added</th>
            <th>Date Sent</th>
            <th style={{ width: "80px" }}>Actions</th>
          </tr>
        </thead>
      </DataTable>
      {
        showRecipientUsersDialog ? (
          <RecipientUsersDialog
            emailCampaign={emailCampaign}
            onAddRecipients={(newRecipients) => {
              const updatedRecipients = [...localRecipients];
              newRecipients.forEach((recipient) => {
                if (!updatedRecipients.find((r) => r.public_id === recipient.public_id)) {
                  updatedRecipients.push(recipient);
                }
              });
              setLocalRecipients(updatedRecipients);
              onSelect(updatedRecipients);
            }}
            show={showRecipientUsersDialog}
            onClose={() => setShowRecipientUsersDialog(false)}
            onOK={() => setShowRecipientUsersDialog(false)}
            okText="Save"
            closeText="Close"
          />) : null}
      {
        deleting ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              transform: "translate(-50%, -50%)",
              zIndex: 1000,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              border: "1px solid #ccc",
            }}
          >
            <i
              className="fas fa-circle-notch fa-spin"
              style={{ fontSize: "50px", textAlign: "center" }}
            ></i>
            <div style={{ fontSize: "20px", fontWeight: "bold" }}>
              Deleting...
          </div>
          </div>
        ) : null
      }
    </div >
  );
};

export default RecipientsTable;
